import React from 'react';
import { Link } from 'react-router-dom';

function Prices({ data }) {
  const stats = [
    {
      id: 1,
      name: ' برای کاربران خارج از ایران',
      value: '85',

      RealValue: '85 € ',
      realValueDesc: 'ارزش واقعی دوره',
      currency: '€',
    },
    {
      id: 2,
      name: 'برای کاربران داخل ایران',
      value: '۴،۴۴۴،۰۰۰ ',
      RealValue: '۴،۴۴۴،۰۰۰ تومان',
      realValueDesc: 'ارزش واقعی دوره',
      discountDesc: 'فقط تا آخر هفته',
      currency: 'تومان',
    },
  ];

  return (
    <section className="text-gray-600 body-font bg-transparent">
      <span className="text-red-500 text-sm md:text-base  w-fit px-2 py-1 rounded-md my-2 w-full">
        {/* <div className="text-lg font-bold  md:text-3xl text-main text-center">
          فقط تا آخر هفته با تخفیف Black Friday ثبت نام کنید!
        </div> */}
      </span>
      <div className="text-main flex flex-col lg:px-2 lg:py-2 bg-lighter text-white mx-2 rounded	">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div
              className="flex flex-col items-center p-4 my-1 justify-between border-b-2 border-gray-200
            ">
              <div className="row-span-1">
                {/* <span className="text-main  text-sm md:text-base">
                  {stat?.realValueDesc}
                </span> */}
                <span className="text-main text-sm md:text-md">
                  {stat.name}
                </span>{' '}
                {/* <span className="text-red-500 text-sm md:text-base">
                  {' '}
                  {stat?.discountDesc}
                </span> */}
              </div>
              <div className="row-span-2">
                <h6 className="mr-2 text-xl font-bold md:text-3xl text-main text-right">
                  {/* <span className="text-main font-bold text-xl md:text-base line-through mx-2">
                    {stat?.RealValue}
                  </span> */}
                  {stat.value} {stat.currency}
                </h6>
              </div>
            </div>
          ))}
        </div>
        <Link
          style={{
            textDecoration: 'none',
            margin: '0 10px',
          }}
          to={`https://academy.azishafiei.com/register`}
          state={{ data: data }}>
          <button
            className="

                  bg-gold hover:bg-silver text-main font-bold hover:text-main py-2 px-2 border border-blue-500 hover:border-transparent rounded w-full my-2 ">
            ثبت نام
          </button>
        </Link>
      </div>
    </section>
  );
}

export default Prices;
